import DomainException from '~/modules/Exceptions/Domain/DomainException'

export default class ChainProviderDomainException extends DomainException {
  public static noChainProvidedId = 'chain_provider_no_chain_provided'
  public static chainIsNotSupportedId = 'chain_provider_chain_is_not_supported'

  public static noChainProvided (): ChainProviderDomainException {
    return new ChainProviderDomainException('Provide a supported NEXT_PUBLIC_CHAIN_ID', this.noChainProvidedId)
  }

  public static chainNotSupported (chainId: number): ChainProviderDomainException {
    return new ChainProviderDomainException(`Chain ${chainId} not supported`, this.chainIsNotSupportedId)
  }
}
